// extracted by mini-css-extract-plugin
export default {"reports-nav":"styles_reports-nav__jCQRb"};